import { Box, Typography, Stack, Button } from '@mui/material';
import { PDFViewer } from '@react-pdf/renderer';
import { Link as RouterLink } from 'react-router-dom';
import useLocales from '#/hooks/useLocales';
import Iconify from '#/components/shared/ui/Iconify';
import React from 'react';

interface BlurredPDFViewerProps {
  children: React.ReactElement;
  width?: string | number;
  height?: string | number;
  showToolbar?: boolean;
}

const BlurredPDFViewer = ({
  children,
  width = '100%',
  height = '550px',
  showToolbar = false,
}: BlurredPDFViewerProps) => {
  const { translate } = useLocales();

  return (
    <Box
      sx={{
        position: 'relative',
        width,
        height,
      }}
    >
      {/* Blurred PDF Preview */}
      <Box
        sx={{
          filter: 'blur(8px)',
          '-webkit-filter': 'blur(8px)',
          pointerEvents: 'none',
          userSelect: 'none',
          width: '100%',
          height: '100%',
        }}
      >
        <PDFViewer
          style={{
            width: '100%',
            height: '100%',
          }}
          showToolbar={showToolbar}
        >
          {children}
        </PDFViewer>
      </Box>

      {/* Upgrade Prompt Overlay */}
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxWidth: '400px',
          padding: '2rem',
          textAlign: 'center',
          background: 'rgba(255, 255, 255, 0.95)',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
          backdropFilter: 'blur(20px)',
          '-webkit-backdrop-filter': 'blur(20px)',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.18)',
        }}
      >
        <Stack spacing={3} alignItems="center">
          <Box
            sx={{
              width: '64px',
              height: '64px',
              borderRadius: '50%',
              backgroundColor: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: 0.1,
            }}
          >
            <Iconify icon="eva:lock-fill" width={32} height={32} />
          </Box>

          <Stack spacing={1} textAlign="center">
            <Typography variant="h6" fontWeight="bold">
              {String(translate('global.needSubscription'))}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {String(translate('global.previewOnlyMessage'))}
            </Typography>
          </Stack>

          <Button
            component={RouterLink}
            to="/dashboard/user/account?billing=true"
            variant="contained"
            color="primary"
            size="large"
            startIcon={<Iconify icon="eva:arrow-upward-fill" />}
            sx={{
              minWidth: '200px',
              fontWeight: 'bold',
            }}
          >
            {String(translate('global.upgradePlan'))}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default BlurredPDFViewer;
